// lib
import queryString from "query-string";
// src
import config from "config";

const createTicketQuery = queryString.stringify({
  service: config.cas.createTicketCallback,
});

export const createTicketRequestURL = `${config.cas.createTicketURL}?${createTicketQuery}`;
export const { logoutURL } = config.cas;
